"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EResidenceFiscale = void 0;
exports.EResidenceFiscale = {
    franceDomTom: "franceDomTom",
    UE: "UE",
    horsUE: "horsUE",
};
